import { Card, Typography, Row, Col } from 'antd';
import { CheckCircleFilled, CheckCircleOutlined, MinusCircleFilled } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

export default function CheckListHeader({ completedSections, onSubmitApplication, finalId, formStatus }) {
  const sections = [
    { key: 'personalInfo', label: 'Personal Information' },
    { key: 'professionalExperience', label: 'Professional Experience' },
    { key: 'volunteerismInformation', label: 'Volunteerism Information' }
  ];

  const allSectionsCompleted = sections.every(section => completedSections[section.key]);

  const tooltipTitle = allSectionsCompleted
    ? 'All required sections are complete. Click to submit your application.'
    : `Please complete all the section(s) before submitting.`;
  if (finalId > 0) formStatus.displaySubmissionButton = false;

  return (

    <Card
      style={{
        boxShadow: '2px 3px 6px #00000029',
        border: ' 1px solid #D0D0D0',
        borderRadius: '10px',
        maxWidth: '1000px',
        width: '100%',
        backgroundColor: '#FAF5F0',
        marginLeft: "auto",
        marginRight: "auto"
      }}
    >
      {!formStatus.submissionAllowed && !formStatus.displaySubmissionButton ? (
        <div style={{ textAlign: 'center' }}>
          <CheckCircleOutlined style={{ fontSize: '24px', color: '#52c41a' }} />
          <p style={{ marginTop: 8, color: '#52c41a' }}>
            <b>Your profile has been added to the Volunteer Scientists database. You may update your profile when necessary.</b>
          </p>
        </div>
      ) : (
        <>
          <Title level={4} style={{ marginBottom: '8px' }}>Progress</Title>

          <Row gutter={[16, 16]} justify="center" align="middle">
            {sections.map(section => (
              <Col key={section.key} xs={24} sm={8} md={8} >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {completedSections[section.key] ? (
                    <CheckCircleFilled style={{ color: '#3EB877', marginRight: '2px', fontSize: '20px' }} />
                  ) : (
                    <MinusCircleFilled style={{ color: '#D0D0D0', marginRight: '2px', fontSize: '20px' }} />
                  )}
                  &nbsp;
                  <Text style={{ fontSize: '16px' }} strong>{section.label}</Text>
                </div>
              </Col>
            ))}
          </Row>
        </>
      )}
    </Card >
  )
}
